import { render, staticRenderFns } from "./afterSaleDetail.vue?vue&type=template&id=7b18c490&scoped=true"
import script from "./afterSaleDetail.vue?vue&type=script&lang=js"
export * from "./afterSaleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b18c490",
  null
  
)

export default component.exports